<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="12">
                <v-card>
                    <v-card-title class="mx-3 px-0 mb-3" style="border-bottom: 2px solid #d7531f">
                        <v-col v-if="paginaAtual === 0" cols="12" md="12">
                            <v-icon style="margin-right: 20px; color: #00294b" size="50">
                                mdi-message-text
                            </v-icon>
                            Minhas interações
                        </v-col>

                        <v-col v-if="paginaAtual === 1" cols="12" md="12" class="d-flex align-center">
                            <v-btn @click="room=undefined;paginaAtual = 0" text>
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-avatar size="62" class="mx-1">
                                <v-img width="70" height="70" contain rounded src="../assets/imagePlaceHolder.jpeg">
                                </v-img>
                                <!-- <img :src="require(`@/assets/${conversas.avatar}`)" alt="John"> -->
                            </v-avatar>
                            <div>
                                <h2>{{partner.name}}</h2>
                            </div>
                        </v-col>
                    </v-card-title>

                    <v-col cols="12" md="12">
                        <v-carousel class="heightCarouselMob paddingMobileChat" height="60vh" v-model="paginaAtual"
                            :show-arrows="false" hide-delimiters>
                            <v-carousel-item>
                                <v-row class="hoverLine" v-for="(conversas, i) in chats" :key="i"
                                    style="cursor: pointer; padding:15px; border-top: 1px solid #f0f0f0; border-bottom: 1px solid #f0f0f0;"
                                    align="center">
                                    <v-col @click="abrirSala(conversas)" cols="8" md="8" class="d-flex align-center"
                                        style="padding: 0px !important">
                                        <v-avatar size="48" class="mx-2">
                                            <v-img width="70" height="70" contain src="../assets/imagePlaceHolder.jpeg">
                                            </v-img>
                                            <!-- <img :src="require(`@/assets/${conversas.avatar}`)" alt="John"> -->
                                        </v-avatar>
                                        <div class="d-flex flex-column justify-center">
                                            <h2 class="nameUserMobile">{{conversas.partner === $store.getters.idUser ?
                                            conversas.client_id.name
                                            : conversas.partner_id.name }}</h2>
                                            <p style="margin-bottom: 0px !important">{{conversas.chat_id.length > 0 ?
                                            conversas.chat_id[0].content : "-"}}</p>
                                        </div>
                                    </v-col>
                                    <v-col cols="4" md="4" class="d-flex"
                                        style="padding: 0px !important; align-items: end; justify-content: end; flex-direction: column;">
                                        <div style="padding: 10px 0">
                                            <p style="margin-bottom: 0px !important; font-size: 10px">
                                                {{conversas.createdAt |
                                                brDateTime}}</p>
                                        </div>
                                        <div>
                                            <span v-if="conversas._count.chat_id > 0"
                                                class="notification">{{conversas._count.chat_id}}</span>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-carousel-item>

                            <v-carousel-item>
                            </v-carousel-item>
                        </v-carousel>
                    </v-col>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
    name: "painelInteracoes",
    data: () => ({
        socket: undefined,
        paginaAtual: 0,
        room: undefined,
        chats: [],
        partner: {},
        messages: [],
        message: ""
    }),
    mounted() {
        
        
        this.$root.$io.on('notification', data => {
            const dt = JSON.parse(data)
            this.chats.forEach(el => { 
                //console.log({el: el.id, dt: dt.chat_partner})
                if (el.id === dt.chat_partner) { 
                    el._count.chat_id++;
                    if (el.chat_id.length > 0) { 
                        el.chat_id[0] = dt
                    }
                }
            }) 
        })
        this.reloadChats();
    },
    watch: {
        paginaAtual(nValue) { 
            if (nValue === 0) { 
                this.reloadChats()
            }
        }
    },
    methods: {
        reloadChats() { 
            this.$root.$io.emit("getChats", {
                id: this.$store.getters.idUser,
            }, dt => {
                //console.log(dt)
                this.chats = dt[0]
            })
        },
        goDown() {
            let container = document.getElementById("messages")
            // console.log( container)
            container.scrollTop = container.scrollHeight;
        },
        abrirSala(chat) {
            //console.log(partner)
            this.partner = (chat.partner === this.$store.getters.idUser) ? chat.client_id : chat.partner_id
            this.paginaAtual = 1
           if (chat._count.chat_id > 0) { 
                --chat._count.chat_id
                this.$root.$emit("decreaseNotification")
           }
        },
    }
}
</script>

<style scoped>
.nameUserMobile {
    font-size: 16px !important;
}

.notification {
    background-color: #ff8629;
    padding: 2px 6px;
    border-radius: 20px;
    color: #fff;
    font-size: 12px;
}


.heightMobile {
    scroll-behavior: smooth;

}

@media (min-device-width: 300px) and (max-device-width: 855px) {
    .paddingMobileChat {
        padding: 0px !important;
    }

    .heightMobile {
        min-height: 60vh !important;
        max-height: 60vh !important;
    }

    .heightCarouselMob {
        height: 80vh !important;
    }

    .btnMobile {
        height: 40px !important;
        width: 100% !important;
    }
}

.hoverLine:hover {
    background-color: #f0f0f0;
}

.box1 {
    display: flex;
    min-width: 100%;
}

.box2 {
    display: flex;
    flex-direction: row-reverse;
    min-width: 100%;
}

.box1 p {
    margin: 10px 0;
    padding: 10px 20px;
    border: 1px solid #f0f0f0;
    border-radius: 50px;
}

.box2 p {
    margin: 10px 0;
    padding: 10px 20px;
    background-color: #f0f0f0;
    border: 1px solid #f0f0f0;
    border-radius: 50px;
}
</style>